<template>
  <section class="section-blog-navigation-links">
    <div class="container">
      <nav class="blog-nav-links">
        <router-link
          class="blog-nav-link"
          v-for="(link, idx) in links"
          :key="idx"
          :to="link.url"
        >
          {{link.name}}
        </router-link>
      </nav>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import {blog} from '@/staticData/routesName/blog'
export default {
  computed: {
    ...mapState('blog', {
      categories: state => state.category
    }),
    links() {
      return this.categories.map(item => ({
        url: `${blog}/${item.url}`,
        name: item.title
      }))
    }
  }
}
</script>
